export const en = () => import('./en.json');
export const sv = () => import('./sv.json');
